import { Card } from '@/components/ui/card';
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer,
  Legend,
} from 'recharts';

interface TimeTrackingData {
  project: string;
  hours: number;
  budget: number;
}

interface TimeTrackingChartProps {
  data: TimeTrackingData[];
}

export function TimeTrackingChart({ data }: TimeTrackingChartProps) {
  return (
    <Card className="p-6 border-gray-100 shadow-card">
      <div className="mb-4">
        <h3 className="text-lg font-semibold text-gray-900">Time Tracking</h3>
        <p className="text-sm text-gray-500 mt-1">Hours logged by project</p>
      </div>
      <div className="h-[300px]">
        <ResponsiveContainer width="100%" height="100%">
          <BarChart data={data}>
            <CartesianGrid strokeDasharray="3 3" stroke="#E5E7EB" />
            <XAxis
              dataKey="project"
              tick={{ fill: '#6B7280', fontSize: 12 }}
              tickLine={{ stroke: '#E5E7EB' }}
            />
            <YAxis
              tick={{ fill: '#6B7280', fontSize: 12 }}
              tickLine={{ stroke: '#E5E7EB' }}
              label={{ value: 'Hours', angle: -90, position: 'insideLeft', style: { fontSize: 12 } }}
            />
            <Tooltip
              contentStyle={{
                backgroundColor: 'white',
                border: '1px solid #E5E7EB',
                borderRadius: '8px',
                boxShadow: '0 4px 12px 0 rgb(0 0 0 / 0.08)',
              }}
              formatter={(value: number, name: string) => [
                `${value} hours`,
                name === 'hours' ? 'Logged' : 'Budget',
              ]}
            />
            <Legend
              wrapperStyle={{ fontSize: '12px' }}
              iconType="rect"
            />
            <Bar
              dataKey="hours"
              fill="#4F46E5"
              radius={[4, 4, 0, 0]}
              name="Hours Logged"
            />
            <Bar
              dataKey="budget"
              fill="#E0E7FF"
              radius={[4, 4, 0, 0]}
              name="Budget Hours"
            />
          </BarChart>
        </ResponsiveContainer>
      </div>
    </Card>
  );
}
